import { render } from "./TransparentInfoCard.vue?vue&type=template&id=e24fb882"
import script from "./TransparentInfoCard.vue?vue&type=script&lang=js"
export * from "./TransparentInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__